//Margin conventions
var margin = {top: 0, right: 60, bottom: 0, left: 52};

var widther = d3.select(".fundingChart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 50 - margin.top - margin.bottom;

var barHeight = 20;   

//format for commas
format = d3.format("0,000");   

//Appends the svg to the chart-container div
var svg = d3.select(".fundingChart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0)
  .domain(["Caddo", "LA avg."]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .orient("left");

//Defines the x axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .orient("top")
  .ticks(5)
  .tickSize(-height); 

//Local data
var data=[{"category":"Caddo","num":2.66},
          {"category":"LA avg.","num":2.36}];           

//Draw the chart
ready(data);

function ready(data) {

  //FORMAT data
  data.forEach(function(d) {
    d.num = +d.num;
  });

  //Sets the max for the xScale
  var maxX = 4;

  //Gets the min for bar labeling
  var minX = d3.min(data, function(d) { return d.num; });

  //Defines the xScale max
  xScale.domain([0, maxX ]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis);

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.category) + ")";
    });

  //Appends main bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.num); })
    .attr("height", barHeight - 1 )
    .attr("class", "g-num")
    .attr("transform", "translate(-4,4)"); 

    //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis);   
  
  
  //Binds data to labels
  var labelGroup = svg.selectAll("g-num")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.category) + ")";
    });

  //Appends main bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return format(d.num) + "x";})
    .attr("x", function(d) { 
        return xScale(d.num) + 2;})
    .attr("y", y0.rangeBand()/1.5)
    .style("fill", "#333333")
    .attr("class", "g-labels");         


  //RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 60, bottom: 0, left: 52};


    //Get the width of the window
    var w = d3.select(".fundingChart").node().clientWidth;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", w);

    //Change the xScale
    xScale
      .range([0, w - newMargin.right - newMargin.left]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.num); });

    //Updates bar labels
    barLabels
      .attr("x", function(d) { 
        return xScale(d.num) + 5;})
      .attr("y", y0.rangeBand()/1.5)


    //Updates xAxis
    xAxisGroup
      .call(xAxis);   

    //Updates ticks
    xAxis
      .scale(xScale);
  };

}
